
<template>
  
 
        <textarea type="text"
                  :name="Name"
                  ref="Element"
                  v-on:click="OnClick"
                  v-on:focus="OnFocus"
                  v-on:blur="OnBlur"
                  :disabled="!FinalEnabled"
                  v-show="FinalVisible"
                  :readonly="FinalReadOnly"
                  :MinLength="m_Attribute.MinLength"
                  :MaxLength="m_Attribute.MaxLength"
                  :DataType="m_Attribute.DataType"
                  :nullable="(!FinalRequired)+''"
                  @keydown="OnKeyDown"
                  @keyup="OnKeyUp"
                  @change="OnValueChange"
                  v-model="m_Value"></textarea>

 
</template>

<script>
    import Utility from '@/Common/Utility'
    import TControlBase from '@/Common/TControlBase';
 
    export default {
        data() {
            return {
                m_Value :"",
                TempElementId : null,
                TempElement: null,
                HasInitializeTempElementHeight: false,
                pressedKeyCodeMap : {} ,
                m_Attribute: TControlBase.Attribute({
                            Nullable: false,
                            Enabled: true,
                            Visible: true,
                            ReadOnly: false,
                            MaxLength: null
                      }
               )
            }
        }
        ,

        //�u�� AutoGrow �ݭn ��L�~�� BaseProps
        //props: ["value", "Attribute", "nullable" ,"AutoGrow", "AutoTrim", "MaxLength","Enabled","Name"],
        props: ["AutoGrow",...TControlBase.BaseProps],


        computed: {

        },

        methods: {

            OnClick(e) {
                this.$emit("click", e);
            },

            OnValueChange(e) {
                this.DoOnValueChange(e);
            },

           
            OnBlur(e) {
                //if (this.AutoTrim == true || this.AutoTrim == "true") {
                //    this.TextAreaValue = this.TextAreaValue.trim();
                //}

                //this.OnValueChange(e);
          
                this.DoOnValueChange(e);
            },

            OnFocus(e) {
                //this.TempElement.style.height = this.$refs.Element.clientHeight + "px";
                 this.PrepareTempTextArea();
                 this.PrepareTempTextAreaStyle();
            },

            UpdateElementByAttribute() {

            },

 



            PrepareTempTextAreaStyle() {
                let tempTextAreaElement;
                let minHeight;

                tempTextAreaElement = document.getElementById(this.TempElementId);

                tempTextAreaElement.style.width = this.$refs.Element.clientWidth + "px";
                tempTextAreaElement.style.fontSize = document.defaultView.getComputedStyle(this.$refs.Element).fontSize;
                tempTextAreaElement.style.fontWeight = document.defaultView.getComputedStyle(this.$refs.Element).fontWeight;
                tempTextAreaElement.style.fontStyle = document.defaultView.getComputedStyle(this.$refs.Element).fontStyle;
                tempTextAreaElement.style.letterSpacing = document.defaultView.getComputedStyle(this.$refs.Element).letterSpacing;

                //PORBLEM
                //tempTextAreaElement.style.lineHeight = document.defaultView.getComputedStyle(this.$refs.Element).lineHeight;

                 minHeight = window.getComputedStyle(this.$el, null).getPropertyValue("min-height");

                //PORBLEM
                //tempTextAreaElement.style.minHeight = minHeight;

                 
                return tempTextAreaElement;
            } ,

            PrepareTempTextArea() {
                let tempTextAreaElement;
                let tempGroupElement;
                 
                tempGroupElement = document.getElementById("TempGroup");
                if (tempGroupElement == null) {
                    tempGroupElement = document.createElement("DIV");
                    tempGroupElement.id = "TempGroup";
                    tempGroupElement.style.height = "2px";
                    tempGroupElement.style.paddingTop = "20px";
                    tempGroupElement.style.opacity = 0;
                    document.body.insertAdjacentElement("BeforeEnd", tempGroupElement);
                }

                tempTextAreaElement = document.getElementById(this.TempElementId);

                if (tempTextAreaElement == null) {
                    tempTextAreaElement = document.createElement("TextArea");
                    tempTextAreaElement.id = this.TempElementId;
        
                    tempTextAreaElement.style.height = "";
                    tempTextAreaElement.style.display = "";
                    tempGroupElement.insertAdjacentElement("BeforeEnd", tempTextAreaElement);
                }

                 

                //tempTextAreaElement.style.height = this.$refs.Element.clientHeight + "px";

                return tempTextAreaElement;
            } ,

            OnKeyDown(e) { 
                 
                //Backspace or Delete
                if (e.keyCode == 8 || e.keyCode == 46) {
                    setTimeout(
                        () => {
                            this.TempElement.value = this.$refs.Element.value;
                            this.CodeEditorAutoResize(e);
                        } ,
                        100
                    );
                }
                else {                                 
                    this.TempElement.value = this.$refs.Element.value + String.fromCharCode(e.which);
                    this.CodeEditorAutoResize(e);
                }


                this.pressedKeyCodeMap[e.keyCode] = true;

                if (this.pressedKeyCodeMap[17] && this.pressedKeyCodeMap[83]) {
                    this.pressedKeyCodeMap[17] = false;
                    this.pressedKeyCodeMap[83] = false;

                    e.preventDefault();
   
                    this.$emit("input", this.$refs.Element.value);

                    //return false;
                }


            },

 
            OnKeyUp(e) {
                this.pressedKeyCodeMap[event.keyCode] = false;

                this.DoOnValueInput(e);

                //this.$emit("input", this.$refs.Element.value);
                //this.OnValueChange(e);
            } ,


            CodeEditorAutoResize(e) {
                let element;
                let tempElement;

           
                if (this.AutoGrow == true || this.AutoGrow == "true") {
                     
                    element = this.$refs.Element;
                    tempElement = this.TempElement;
                    
                    if (
                        element.getAttribute("LastScrollHeight") != (tempElement.scrollHeight + 0)
                    ) {
                        //element.style.height = "5px";

                        if (tempElement.scrollHeight > 10) { 
                        element.style.height = (tempElement.scrollHeight + 0) + "px";
                        //console.log("set element.style.height=" + (tempElement.scrollHeight) + "px");
                        element.setAttribute("LastScrollHeight", (tempElement.scrollHeight + 0));
                        }
                    }
                }
            },

            

        },

        mounted() {
            this.TempElement = this.PrepareTempTextArea();
             
            this.DoOnMounted();
 
            if (this.AutoGrow == true || this.AutoGrow == "true") {
                this.$bus.$on('TabChanged',
                    function (event) {

                        setTimeout(
                            () => {
                                this.CodeEditorAutoResize();
                            },
                            100
                        );
                    }.bind(this)
                );

                setTimeout(
                    function () {
                        if (this.$el.clientHeight < this.$el.scrollHeight) {
                             
                            this.$el.style.height = (this.$el.scrollHeight + "px");
                        }
                        //this.CodeEditorAutoResize();
                    }.bind(this)
                    ,
                    10
                );

                setTimeout(
                    function () {
                        if (this.$el.clientHeight < this.$el.scrollHeight) {
                            this.$el.style.height = (this.$el.scrollHeight + "px");
                        }
                        //this.CodeEditorAutoResize();
                    }.bind(this)
                    ,
                    100
                );
            }
        },

        created() {
            TControlBase.call(this);

            //this.m_Value = this.value;

            //if (this.Attribute != null) {
            //    Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
            //}

            //this.TempElementId = "TempTextArea_"+Utility.GenerateSerialNumber();
            //this.UpdateElementByAttribute();


            //if (this.MaxLength != null) {
            //    this.m_Attribute.MaxLength = this.MaxLength;
            //}

            //if (this.Enabled != null) {
            //    if ((this.Enabled + "").toLocaleLowerCase() == "true") {
            //        this.m_Attribute.Enabled = true;
            //    }
            //    else {
            //        this.m_Attribute.Enabled = false;
            //    }
            //}

            //if (this.nullable == false || this.nullable == "false") {
            //    this.m_Attribute.Nullable = false;
            //}
            //else {
            //    this.m_Attribute.Nullable = true;
            //}
        },


        beforeDestroy: function () {
            let element;

            element = this.$refs.Element;

            element.removeAttribute("LastScrollHeight");
            this.$bus.$off('TabChanged');
        } ,

        watch: {

            //nullable: function (newVal) {

            //    if (newVal == false || newVal == "false") {
            //        this.m_Attribute.Nullable = false;
            //    }
            //    else {
            //        this.m_Attribute.Nullable = true;
            //    }
            //},

            //Enabled: function (newVal, oldVal){

            //    if (newVal != null) {
            //        if ((newVal + "").toLocaleLowerCase() == "true") {
            //            this.m_Attribute.Enabled = true;
            //        }
            //        else { 

            //            this.m_Attribute.Enabled = false;
            //        }
            //    }
            //},

            //Attribute: function (newVal, oldVal) {
            //    Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);
            //},

            value: function (newVal, oldVal) {

                if (this.PropertyChangeTimeSet["TheCurrentValue"] != null &&
                    (new Date() - this.PropertyChangeTimeSet["TheCurrentValue"]) < 20
                ) {
                    return;
                }

                if (this.m_Attribute.DataType == "Date") {
                    this.m_Value = Utility.GetDateText(newVal);
                }
                else {
                    this.m_Value = newVal;
                }

                setTimeout(
                    function () {
                        if (this.AutoGrow == true || this.AutoGrow == "true") {
                            if (this.$refs.Element != null) {
                                if (this.$refs.Element.clientHeight < this.$refs.Element.scrollHeight) {
                                    this.$refs.Element.style.height = (this.$refs.Element.scrollHeight + "px");
                                }
                            }
                        }
                        //this.CodeEditorAutoResize();
                    }.bind(this)
                    ,
                    100
                );

                this.ClearError();
            }
        }


    }
</script>

<style>
</style>
